// extracted by mini-css-extract-plugin
export default {"actions":"Pruebas_actions__YGGOL","download":"Pruebas_download__H1RHt","fecha":"Pruebas_fecha__DPUJF","banner":"Pruebas_banner__mw3uu","link":"Pruebas_link__1XJHN"};